import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "sonner";
import { queryClient } from "@/shared/api/query-client";
import { SentryErrorBoundary } from "@/shared/components/ui/error-boundary";

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <SentryErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {children}
        <Toaster richColors closeButton />
        {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
      </QueryClientProvider>
    </SentryErrorBoundary>
  );
}
